// extracted by mini-css-extract-plugin
export default {"Card":"BookModal_Card__yzo7z","Img":"BookModal_Img__mlaCr","Text":"BookModal_Text__bVjn0","Modal":"BookModal_Modal__YdxOI","Title":"BookModal_Title__J-+q6"};